module.exports = __webpack_public_path__ + "static/media/crownOff_326.65f36e6d.png";